import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-typeform-response-renderer',
  templateUrl: './typeform-response-renderer.component.html',
  styleUrls: ['./typeform-response-renderer.component.css']
})
export class TypeformResponseRendererComponent implements OnInit {

  @Input()
  response: any;

  data: { question: string, answer: string }[] = [];

  constructor() { }

  ngOnInit() {
    this.transform();
  }

  private getHiddenFieldValue(id: string) {
    return this.response.form_response.hidden[id];
  }

  private getRawQuestionById(id: string) {
    return this.response.form_response.definition.fields.filter((field) => field.id === id)[0];
  }

  private getRawQuestionByRef(ref: string) {
    return this.response.form_response.definition.fields.filter((field) => field.ref === ref)[0];
  }

  private getRawAnswerById(id: string) {
    return this.response.form_response.answers.filter((answer) => answer.field.id === id)[0];
  }

  private renderRawQuestion(rawQuestion) {
    let title: string = rawQuestion.title;

    const matches = title.match(/\{\{(.*?)\}\}/g);
    if (matches && matches.length > 0) {
      for (const match of matches) {
        const prefixField = "{{field:";
        const prefixHidden = "{{hidden:";
        const suffix = "}}";
        if (match.indexOf(prefixField) === 0) {
          const ref = match.substring(prefixField.length, match.length - suffix.length);
          const referencedQuestion = this.getRawQuestionByRef(ref);
          const referencedAnswer = this.getRawAnswerById(referencedQuestion.id);
          const value = this.renderRawAnswer(referencedAnswer);
          title = title.replace(match, value);
          // FIXME: replaceAll

        } else if (match.indexOf(prefixHidden) === 0) {
          const id = match.substring(prefixHidden.length, match.length - suffix.length);
          const value = this.getHiddenFieldValue(id);
          title = title.replace(match, value);
          // FIXME: replaceAll
        } else {
          console.warn("Cannot interpolate " + match);
        }
      }
    }

    return title;
  }

  private renderRawAnswer(rawAnswer) {
    switch (rawAnswer.type) {
      case "boolean":
        return rawAnswer.boolean ? "Sì" : "No";
      case "text":
        return rawAnswer.text;
      case "email":
        return rawAnswer.email;
      case "number":
        return rawAnswer.number;
      case "choice":
        return rawAnswer.choice ? rawAnswer.choice.label : null;
      case "date":
        return rawAnswer.date;
      case "date":
        return rawAnswer.date;
      case "choices":
        return rawAnswer.choices && rawAnswer.choices.labels ? rawAnswer.choices.labels.join(", ") : null;
      case "payment":
        return rawAnswer.payment ? rawAnswer.payment.amount : null;
      default:
        return;
    }
  }

  stripHtml(s: string) {
    return s ? s.replace(/<.*?>/g, '') : s;
  }

  transform() {
    for (const rawAnswer of this.response.form_response.answers) {
      const rawFieldId = rawAnswer.field.id;
      const rawQuestion = this.getRawQuestionById(rawFieldId);

      const question = this.renderRawQuestion(rawQuestion);
      const answer = this.renderRawAnswer(rawAnswer);

      this.data.push({
        question,
        answer: answer ? answer.toString() : answer
      });
    }
  }

}
